export default {
  nav: {
    dashboard: 'ダッシュボード',
    teams: 'チーム＆ロスター',
    masterManagement: 'リーグ・選手マスター管理',
    videoAnalytics: '映像解析＆AIリプレイ',
    training: '動作解析＆個別トレ',
    recruiting: '大学スカウト＆進路相談',
    playerRecruiting: 'プロスカウト＆進路',
    parentRecruiting: '大学スカウト＆進路ポータル',
    lineup: 'スタメン＆守備配置',
    liveGame: '試合スコア＆投球数',
    events: 'スケジュール＆出欠',
    billing: '決済＆サービス契約 (Stripe)',
    settings: '組織設定',
    management: '管理メニュー',
    adminMenu: 'チーム管理者業務',
    coachMenu: 'コーチ・監督メニュー',
    playerMenu: '選手メニュー',
    parentMenu: '保護者ポータル',
    activeContext: '現在の組織コンテキスト',
    switchRole: '表示ロール切替:',
    switchPerspective: '視点を切り替える',
    signOut: 'サインアウト (Clerk)',
    createJoinOrg: '組織を作成 / 参加',
    clerkOrgs: '所属組織一覧 (テナント)',
    notifications: '通知',
    playerHub: '選手マイページ',
    playerRoster: 'チームロスター',
    playerLineup: '試合オーダー表',
    playerSchedule: '日程・出欠回答',
    playerBilling: '会費支払い＆Stripe決済',
    parentHub: '保護者ホーム',
    parentDirectory: 'チーム名簿・連絡先',
    parentLogistics: '日程・送迎スケジュール',
    parentLineup: '試合オーダー確認',
    parentBilling: '会費・追加オプション決済',
  },
  tenantReg: {
    pageTitle: '野球組織・クラブ新規登録',
    pageSubtitle: '管理者アカウントを作成し、テナント組織の作成をAPIサーバーに委任します。',
    step1Label: '1. 組織管理者アカウント登録',
    step2Label: '2. 野球組織・クラブ情報',
    managerTip: '組織全体のロスター、契約、設定を統括する「代表管理者 (Org Admin)」アカウントを作成します。',
    fullName: '管理者氏名',
    workEmail: '連絡用メールアドレス (ClerkログインID)',
    phoneOptional: '電話番号 (任意)',
    password: 'パスワード',
    alreadyHaveAccount: 'すでにアカウントをお持ちの方はこちら (ログイン)',
    continueToOrg: '組織情報の入力へ進む',
    orgTip: '野球チーム・クラブの基本情報を設定します。テナントおよびClerk組織の作成はAPIサーバー側で安全にプロビジョニングされます。',
    orgNameLabel: '組織・クラブ名',
    typeLabel: 'テナント種別 (Tenant Type)',
    tierLabel: 'テナント種別',
    types: {
      PRO: 'プロ (Pro)',
      AMATEUR: '社会人・クラブ (Amateur)',
      ACADEMIC: '学生・学校 (Academic)',
      OTHERS: 'その他 (Others)',
    },
    orgSlugLabel: '組織スラグ (識別URL / Clerk ID)',
    apiSyncNotice: 'APIサーバーがテナントおよび組織を安全にプロビジョニング',
    backToManager: '管理者情報に戻る',
    createAndLaunch: '組織を作成して開始',
    successTitle: '組織の登録が完了しました！',
    successMsg: 'APIサーバーが {org} (管理者: {user}) を作成・プロビジョニングしました。',
    sportTypeLabel: '種目 (Sport Type)',
    seasonYearLabel: 'シーズン年度',
    enterCodeLabel: '6桁の認証コードを入力',
    resendCode: '認証コードを再送',
    resendingCode: 'コードを再送中...',
    verifyContinue: '認証して次へ進む',
    editEmail: 'メールアドレスを変更',
    autoFillSocial: 'ソーシャルアカウントで自動入力:',
    orEnterCredentials: 'またはメールで入力',
    clerkModalBtn: 'Clerkモーダル画面',
    passwordPolicyNote: 'Clerkのポリシーによりパスワードは15文字以上が必要です',
    nativeScopingBadge: '独自DBマルチテナント・スコーピング',
    selectedBadge: '選択中',
  },
  master: {
    title: 'リーグ・チームおよび選手マスター管理',
    badge: 'マスターDB',
    subtitle: '{name} の参加リーグ所属チームの登録、自チーム／対戦相手の設定、および選手マスターとテナントユーザーアカウントの紐付けを管理します。',
    ownTeamsCount: '自チーム {count} チーム',
    opponentsCount: '対戦相手 {count} チーム',
    leagueTeamsTab: 'リーグ所属チームマスター ({count})',
    playerMasterTab: '選手マスター＆ユーザーアカウント連携 ({count})',
    searchTeamsPlaceholder: 'マスター内のチーム名やリーグで検索...',
    addMasterTeam: 'マスターチーム追加',
    colTeamName: 'チーム名',
    colLeague: '参加リーグ・大会',
    colDivision: 'ディビジョン / 組',
    colCoach: '監督・ヘッドコーチ',
    colDesignation: '所属区分',
    colActions: '操作',
    ownClub: '自チーム',
    opponent: '対戦相手',
    manageRoster: '名簿管理',
    scouted: '対戦相手',
    searchPlayersPlaceholder: '選手名、背番号、メールアドレスで検索...',
    allTeamsFilter: 'マスター全チーム',
    colJersey: '#',
    colPlayerName: '選手マスター氏名',
    colPrimaryTeam: '所属チーム',
    colPosition: 'ポジション',
    colLinkedUser: '連携テナントユーザー',
    colAccountStatus: 'アカウント状態',
    colUserLinkage: 'ユーザー紐付け',
    notLinked: 'ユーザー未連携',
    inviteSentText: '招待送信済: {email}',
    linkUserBtn: 'ユーザー連携',
    unlinkBtn: '連携解除',
    sendInviteTitle: '招待メール送信',
    unlinkTitle: 'ユーザーアカウントの連携解除',
    linkModalTitle: '選手マスターとテナントユーザーの紐付け',
    linkModalEmailLabel: 'テナントユーザーのメールアドレス (ClerkログインID)',
    linkModalEmailDesc: 'このユーザーがClerkでログインした際、自動的にこの選手のロスター、成績、打順表に接続されます。',
    linkModalSubmit: 'アカウントを連携する',
    addTeamModalTitle: 'リーグマスターチーム新規登録',
    addTeamModalNameLabel: 'チーム名',
    addTeamModalNamePlaceholder: '例: ベイエリア・ボンバーズ 18U',
    addTeamModalLeagueLabel: '参加リーグ名',
    addTeamModalLeaguePlaceholder: '例: プレミア・ショーケース・サーキット',
    addTeamModalDivisionLabel: 'ディビジョン',
    addTeamModalDivisionPlaceholder: '例: バーシティ・プレミア',
    addTeamModalCoachLabel: '監督・指導者名',
    addTeamModalCoachPlaceholder: '例: リック・サンタナ監督',
    addTeamModalDesignationLabel: '所属区分',
    addTeamModalOwnOption: '自チーム / 所属クラブ',
    addTeamModalOpponentOption: 'リーグ対戦相手チーム',
    addTeamModalSubmit: 'マスターチームを保存',
    markedOwnTeam: '自チームに設定しました',
    markedOpponent: 'リーグ対戦相手に設定しました',
    markedDesc: '{name} を {role} として指定しました。',
    userLinked: 'ユーザーアカウントを連携しました',
    userLinkedMsg: '選手 #{num} {name} をClerkユーザー ({email}) に正常に紐付けました。',
    userUnlinked: 'ユーザー連携を解除しました',
    userUnlinkedMsg: '#{num} {name} のユーザー連携を解除しました。',
    inviteDispatched: '招待を送信しました',
    inviteDispatchedMsg: '{target} 宛てにテナント登録の案内メールを送信しました。',
    teamRegistered: 'マスターチームを登録しました',
    teamRegisteredMsg: '{team} を {league} 配下に登録しました。',
  },
  roles: {
    admin: 'チーム管理者 (エレナ)',
    coach: '監督 / 管理者',
    player: '選手 (コール #24)',
    parent: '保護者 (ガーディアン)',
    ADMIN: '組織管理者',
    COACH: '監督・コーチ',
    GUARDIAN: '保護者',
    TEAM_ADMIN: 'チーム管理者',
    HEAD_COACH: '監督・ヘッドコーチ',
    ORG_ADMIN: '組織管理者',
    PLAYER: '選手',
    PARENT: '保護者',
  },
  videoAnalytics: {
    title: '映像解析＆AIテレステーション',
    subtitle: '{name} の4Kハイスピード投球解析、打球初速トラッキング、ストライクゾーン判定',
    bookmarked: '動画を保存しました',
    bookmarkedMsg: '{title} をハイライト集に追加しました。',
  },
  training: {
    title: '動作解析＆スキルトレーニングセンター',
    subtitle: '{name} の球速向上メニュー、週間宿題ドリル、フォームチェック',
    weeklyProgramTitle: '第4週 強化育成プログラム',
    weekProgress: '今週の宿題達成率',
    assignedDrills: '今週の課題ドリル一覧',
    done: '完了',
    uploadDrillVideo: 'ドリル動画を提出',
    drillCompleted: 'ドリルを完了しました！',
    homeworkUploaded: '動画をアップロードしました',
    homeworkUploadedMsg: '自主練動画が指導陣に提出されました。',
  },
  billing: {
    teamAdminTitle: 'チーム決済管理＆サービス契約',
    teamAdminSubtitle: '{name} の支払いタイプ（チーム一括／個別請求）およびStripe契約サービスの管理',
    memberTitle: '会費お支払い＆プラン管理',
    memberSubtitle: 'シーズン部費、個別スキルトレーニングのStripe決済・請求履歴',
    managingTeam: '管理対象チーム:',
    paymentModelTitle: 'チーム支払いモデル設定',
    paymentModelDesc: 'チーム全体のサービス費用をクラブが一括負担するか、各選手・保護者に個別請求するかを設定します。',
    teamPayment: 'チーム一括支払い (クラブ請求)',
    teamPaymentDesc: '全サービスおよび部費をクラブ代表のStripeカードにまとめて一括請求します。',
    individualPayment: '個別支払い (選手・保護者個別請求)',
    individualPaymentDesc: '各選手・保護者へ個別のStripe請求書と決済リンクを発行します。',
    singleStripeInvoice: 'クラブ代表Stripeカードへ一括請求',
    athleteGuardianInvoices: '選手・保護者がポータルから直接決済',
    paymentTypeUpdated: '支払いタイプを更新しました',
    paymentTypeUpdatedMsg: '{team} の支払いタイプを {type} に設定しました。',
    servicesCatalog: 'チーム契約サービス一覧',
    servicesCatalogSubtitle: '映像解析AI、動作解析トレーニング、スカウト配信機能をチームに導入します。',
    videoAnalyticsRule: '映像解析サービスはチーム全体の共有設備のため「チーム一括支払い」のみ対応しています。',
    videoAnalyticsRuleNote: '{name} を「チーム一括支払い」にて契約開始しました。',
    teamOnlyBilling: 'チーム一括払いのみ対応',
    supportsBilling: '{type} に対応',
    includedCore: '基本プラットフォーム (有効)',
    manageCancel: '契約変更 / 解約',
    subscribeStripe: 'Stripeで契約する',
    serviceSubscribed: 'サービスを契約しました',
    serviceSubscribedMsg: '{name} をチーム向けに有効化しました。',
    serviceCanceled: '契約を停止しました',
    serviceCanceledMsg: '{name} は現在の請求期間の終了時に無効化されます。',
    coreRequired: '必須基本機能',
    coreRequiredMsg: 'Baseball Cloud Coreは名簿と日程の管理に必要な基本機能です。',
    memberDuesPortal: '選手アカウント＆部費請求',
    goodStanding: '会費納入完了 (正常)',
    enrolledWith: '{team} 所属中 ({org})',
    seasonDues: '2025年度 シーズン部費',
    individualAddons: '選手個人向け追加オプション',
    skillTrainingTitle: 'スキルトレーニング＆バイオメカニクス',
    skillTrainingAthleteDesc: '球速アップ個別メニュー、打撃動画ドリル、指導者とのダイレクト相談チャット。',
    updatePaymentMethod: 'カード情報変更 (Stripe)',
    changePaymentMethod: '決済方法を変更・選択',
    selectPaymentMethod: '決済方法を選択',
    choosePaymentMethodPrompt: 'サービス契約を有効化するため、組織の決済方法（クレジットカード、銀行振込、コンビニ決済）を選択してください。',
    payWithCard: 'クレジットカード (Stripe)',
    payWithCardDesc: 'Visa, Mastercard, AMEX, JCB等で即時・自動引き落とし決済。',
    payWithBank: '銀行振込 (バーチャル口座 / Furikomi)',
    payWithBankDesc: '専用の振込指定口座への請求書払い・自動照合。',
    payWithKonbini: 'コンビニ決済 (Konbini)',
    payWithKonbiniDesc: 'セブンイレブン、ローソン、ファミリーマート、ミニストップ、セイコーマートで現金払い。',
    manageInStripePortal: 'Stripeカスタマーポータルで管理',
    openStripePortal: 'Stripeカスタマーポータル',
    paymentMethodTitle: '代表マスター決済方法 (テナント管理者)',
    paymentMethodSubtitle: 'チーム一括契約、自動更新、追加サービスの決済に使用される登録支払方法です。',
    noCardOnFile: '決済方法が未選択です。クレジットカード、銀行振込、またはコンビニ決済を選択してください。',
    cardOnRecord: '登録中のクレジットカード',
    defaultMethod: 'デフォルト決済方法',
    activeSubscriptionsTitle: '有効な組織契約一覧',
    activeSubscriptionsSubtitle: 'テナントのStripeアカウントに請求されている稼働中のサブスクリプションです。',
    noActiveSubs: '現在有効なサブスクリプションはありません。下のカタログからプランを選択してください。',
    renewsOn: '更新日: {date}',
    stripeCustomerId: 'Stripe顧客ID:',
    coveredByTeam: 'チーム一括契約に含まれています',
    proceedToStripe: 'Stripe決済ページへ進む',
    confirmPaymentMethod: '決済方法を保存して適用',
    videoAnalyticsPlayerNote: 'チーム管理者が映像解析を契約しているため、全打席の4K解析動画を無料で視聴できます。',
    accessGranted: '映像解析機能を利用可能',
    paymentHistory: 'お支払い・領収書履歴',
    stripeModalTitle: 'Stripe 安全決済',
    amountDueToday: '本日のお支払い合計:',
    cardholderName: 'カード名義人',
    cardNumber: 'カード番号',
    expiryDate: '有効期限',
    cvc: 'セキュリティコード (CVC)',
    payWithStripe: 'Stripeで決済を完了する',
    paymentSuccess: '決済が完了しました！',
    paymentSuccessMsg: '{service} のStripe決済が正常に処理されました。領収書をメールに送信しました。',
    coachRestrictionNotice: 'コーチ権限: ロスター、打順カード、イベント、シート割り当ての管理権限を有します。プランのアップグレードや決済方法の変更は、組織管理者に依頼してください。',
    pendingCancelBadge: '解約手続き中 (期間終了まで利用可能)',
    resumeBtn: 'サブスクリプションを再開',
    manageSeatsBtn: 'シート割り当て管理',
    cancelTeamPlan: 'チームプランを解約',
    subscribeTeamPlan: 'Stripeでチーム契約 (Team)',
    monthlyDuesLabel: '月額会費 (月払い固定):',
    setupRequiredTitle: '初期設定: Stripe支払い方法の登録とサービスの契約',
    setupRequiredDesc: 'Next Baseへようこそ！クレジットカード・銀行振込・コンビニ決済を設定し、{org} の運用モジュールを有効化してください。',
    stripeCheckoutLaunched: 'Stripe決済画面を起動しました',
    redirectingToStripe: '{service} の確認のためStripeへ移動しています...',
    subscriptionActivated: 'サブスクリプションが有効化されました',
    subscriptionActivatedMsg: '{org} に対し {service} が正常に有効化されました。',
    loadingStripeElements: '安全なStripe Elements決済フォームを読み込み中...',
    stripeSecure256: '公式 Stripe.js セキュアAPI',
    stripeDirect256: '公式Stripe.js APIによる256ビット暗号化トークン決済',
    customerLabel: '顧客番号: {id}',
    paylinkGenTitle: 'Stripe支払いリンク生成ツール',
    paylinkGenSubtitle: '保護者や選手にこのURLを共有することで、シーズン会費をオンライン決済で回収できます。',
    copyBtn: 'コピー',
    doneBtn: '完了',
  },
  liveGame: {
    title: '試合実況スコア ＆ 投球数管理 (Pitch Smart)',
    subtitle: '{name} のリアルタイム打席速報・投球制限・球数休息日数計算',
    topInning: '{inning}回表',
    botInning: '{inning}回裏',
    inning: '{inning}回',
    balls: 'ボール (B)',
    strikes: 'ストライク (S)',
    outs: 'アウト (O)',
    atBat: '打席:',
    onDeck: '次打者:',
    pitcher: '登板投手:',
    pitchCount: '投球数',
    pitchLimit: 'Pitch Smart制限: {limit}球',
    restDaysRequired: '必要休息期間: {days}日',
    quickPlays: 'ワンタップ入力',
    ball: '+ ボール',
    strike: '+ ストライク (見逃し/空振り)',
    foul: 'ファウル',
    hitSingle: '単打 (1B)',
    hitDouble: '二塁打 (2B)',
    hitTriple: '三塁打 (3B)',
    homeRun: '本塁打 (HR)',
    strikeout: '三振 (K)',
    walk: '四球 (BB)',
    outInPlay: '凡打・アウト',
    runScored: '+ 得点追加',
    advanceInning: '攻守交代 (次のイニング)',
    resetCount: 'カウントリセット',
    gameLog: '一球速報・実況ログ',
    noPlaysYet: 'まだ記録がありません。上のボタンで打席を入力してください。',
    liveScoreboard: 'スコアボード',
    runnersOnBase: '走者状況',
    clearBases: '走者一掃',
    pitchRecorded: '投球数を記録',
    pitchRecordedMsg: '{pitcher} 投手に {count} 球目を記録しました',
    pitchLimitWarning: '投球数上限警告 (Pitch Smart)',
    pitchLimitWarningMsg: '{pitcher} 投手が {count} 球に達しました (必要な登板間隔: {days}日)。',
  },
  coachDashboard: {
    title: 'クラブ概要 • 監督コマンドセンター',
    subtitle: '{name} のリアルタイム運営状況',
    manageTeams: 'チーム管理',
    activeTeams: '稼働チーム数',
    inSeason: 'シーズン稼働中',
    activeRoster: '登録選手数',
    total: '名中',
    scheduledEvents: '予定イベント数',
    next7Days: '直近7日間',
    winRate: 'クラブ勝率',
    upcomingGames: '今後の試合＆練習予定',
    viewAllSchedule: '全日程を見る',
    clubTeams: '所属チーム一覧',
    manage: '管理',
    confirmed: '出席確認済',
    out: '欠席',
    pending: '未回答',
    game: '試合',
    practice: '練習',
    coach: '監督',
  },
  playerDashboard: {
    welcome: 'お帰りなさい、{name} 選手！',
    battingAvg: '打率 (AVG)',
    exitVelo: '打球初速',
    ops: '出塁率+長打率 (OPS)',
    nextGame: '次の公式戦',
    firstPitch: 'プレイボールまで 36時間',
    reportTime: '集合時間',
    reportTimeVal: '明日 15:00 現地集合',
    uniform: 'ユニフォーム',
    location: '試合会場',
    attendance: 'あなたの出欠状況:',
    confirmedIn: '出席確定 (参加)',
    declinedOut: '不参加',
    imIn: '参加する',
    cannotAttend: '参加できない',
    lineupAssignment: 'あなたの打順・守備位置',
    startingLineup: '先発出場',
    batterHole: '2番打者',
    posShortstop: '守備位置: ショート (SS)',
    card: '打順表',
    coachBulletin: '監督からの連絡ノート',
    coachQuote: '「火曜のブルペンは非常に良かった。打撃練習は16:30厳守で開始します。両方のユニフォームを持参すること。」',
    coachAuthor: '— マーカス "スキップ" ホロウェイ 監督',
    rsvpSuccess: '出欠を登録しました',
    rsvpSuccessMsg: 'チャンピオンシップ戦への参加を登録しました。',
    rsvpDeclined: '欠席を登録しました',
    rsvpDeclinedMsg: 'ホロウェイ監督に欠席理由が通知されました。',
  },
  parentDashboard: {
    title: '保護者ポータル • {name}',
    duesPaid: 'シーズン会費: 納入完了',
    enrolledWith: '{team} に所属中 ({org})',
    gameDayDest: '試合会場・移動情報',
    round1: '第1回 ショーケース大会',
    complexAddress: '球場住所:',
    dropOff: '現地集合・送迎:',
    dropOffVal: '試合開始90分前 (15:00)',
    gameUniform: '着用ユニフォーム:',
    transportConfirmed: '送迎および出欠確認済み',
    athleteMarked: '保護者による出席確認が完了しています。',
    update: '変更する',
    headCoachContact: '監督への直通連絡先',
    medWaiver: 'メディカル＆誓約書ステータス',
    cleared: '承認済み',
    waiverMsg: '2025年度スポーツ健康診断書および免責同意書は受領・確認済みです。',
    rsvpSuccess: '保護者確認を受領しました',
    rsvpSuccessMsg: '{name} 選手の {event} への送迎・参加予定を記録しました。',
  },
  teams: {
    title: 'チーム＆ディビジョン一覧',
    subtitle: '{name} のチーム編成、監督任命、スケジュール管理',
    addNewTeam: '新規チーム作成',
    searchPlaceholder: 'チーム名・ディビジョン・監督名で検索...',
    record: '勝敗成績 (W-L)',
    rosterSize: 'ロスター人数',
    players: '名',
    headCoach: '監督:',
    viewRoster: 'ロスター確認',
    schedule: '日程表',
    noTeams: '該当するチームがありません',
    noTeamsDesc: '現在の絞り込み条件または組織内に登録されたチームはありません。',
    createFirstTeam: '最初のチームを作成',
    createModalTitle: '野球チーム新規作成',
    createModalSubtitle: '{name} 配下に新しいチーム部門を登録',
    teamName: 'チーム名',
    season: 'シーズン',
    division: 'ディビジョン / 所属リーグ',
    teamColor: 'チームカラー',
    cancel: 'キャンセル',
    saveTeam: 'チームを保存',
    billingLabel: '請求形態:',
    teamMaster: 'チーム一括',
    splitDues: '個人別会費',
    paymentModel: '支払い形態',
    teamMasterPayment: 'チーム一括決済',
    individualPlayerDues: '選手個別会費決済',
    syncWithApi: 'APIと同期',
    stripeBilling: 'Stripe請求ポータル',
    videoAnalyticsSubscribed: '動画解析契約中',
    skillTrainingSubscribed: 'スキル指導契約中',
    createTeamFailed: 'チーム作成に失敗しました',
    teamCreatedSuccess: '{name} を作成しました。',
  },
  roster: {
    backToTeams: 'チーム一覧へ戻る',
    activeAthletes: '名のアスリート',
    lineupCard: 'オーダー表',
    addPlayer: '選手を追加',
    seatAllocations: 'シート割り当て管理',
    searchPlaceholder: '選手名、背番号、ポジションで検索...',
    allPositions: '全ポジション',
    playerName: '選手名',
    primaryPos: '主ポジション',
    batsThrows: '投打',
    class: '卒業年',
    status: '状態',
    actions: '操作',
    viewProfile: '詳細を見る',
    noRecords: '条件に一致する選手が見つかりません。',
    addModalTitle: 'ロスターに選手を追加',
    addModalSubtitle: '{team} に新規アスリートを登録',
    firstName: '名 (First Name)',
    lastName: '姓 (Last Name)',
    jersey: '背番号',
    position: 'ポジション',
    emailOptional: 'メールアドレス (任意)',
    gradYear: '卒業予定年',
    addAthlete: '選手を登録',
    playerAdded: '選手を追加しました',
    playerAddedMsg: '#{num} {first} {last} 選手がロスターに加わりました',
  },
  playerModal: {
    title: '選手プロファイル＆測定データ',
    heightWeight: '身長 / 体重',
    exitVelocity: '打球初速 (Exit Velo)',
    armVelocity: '送球速度 (Arm Velo)',
    sprint60: '60ヤード走 (走力)',
    availability: '出場可能ステータス',
    active: '現役・出場可',
    injured: '故障者リスト (IL)',
    reserve: 'リザーブ・待機',
    contacts: '本人・保護者連絡先',
    noEmail: 'メールアドレス未登録',
    scoutingNotes: '監督・コーチ指導メモ＆育成方針',
    saveChanges: '変更を保存',
    profileSaved: '選手データを更新しました',
    profileSavedMsg: '測定値および出場ステータスを保存しました。',
    bats: '打席',
    throws: '投球',
    gradClass: '{year}年度 卒業予定',
  },
  lineup: {
    title: 'スタメンオーダー＆守備配置表',
    badge: '試合前準備',
    subtitle: '{name} の9人制打順および守備シフトを編成',
    autoFill: '自動最適編成',
    saveCard: 'オーダー表を保存',
    battingOrder: '打順 (1〜9番)',
    starters: '先発9名',
    selectBatter: '-- 打者を選択 --',
    defensivePos: '守備位置グラウンド配置',
    synchronized: '同期中',
    cardSaved: 'オーダー表を保存しました',
    cardSavedMsg: '審判交換用の公式打順表が準備できました。',
    autoAssigned: 'スタメンを自動編成しました',
    autoAssignedMsg: '状態の良い主力選手を9番まで自動配置しました。',
    clickToAssign: 'グラウンド上の各ポジションをクリックすると配置選手を確認できます。',
    shiftScheme: '守備シフト体系:',
    shiftStandard: '標準守備位置',
    shiftInfieldIn: '前進守備 (本塁死守)',
    shiftPull: '右打者引っ張り警戒シフト',
    shiftNoDoubles: '長打警戒 (深め配置)',
    fieldHelp: 'グラウンド上のポジションバッジをクリックすると、割り当て選手と守備位置が表示されます。',
    printLineup: 'オーダー表を印刷',
  },
  events: {
    title: 'イベント＆日程管理',
    subtitle: '{name} の試合・練習日程および選手出欠集計',
    scheduleEvent: 'イベントを企画',
    allEvents: '全日程',
    gamesOnly: '公式戦・試合のみ',
    practices: '練習のみ',
    rollCall: '点呼・出欠確認',
    confirmed: '名 出席',
    eventTitle: 'イベント名',
    eventType: 'イベント種類',
    homeAway: 'ホーム / ビジター',
    opponent: '対戦相手 (試合の場合)',
    location: '開催球場・グラウンド',
    eventScheduled: '日程を追加しました',
    eventScheduledMsg: '{title} をカレンダーに登録しました。',
    attending: '出席',
    declined: '欠席',
    pending: '未定・保留',
    saveRollCall: '点呼結果を保存',
    game: '試合',
    practice: '練習',
    scrimmage: '練習試合',
    tryout: 'セレクション / 体験会',
    home: 'ホーム',
    away: 'ビジター',
    syncSchedule: '日程を更新',
    scheduleEventError: 'イベント作成エラー',
  },
  attendanceModal: {
    title: 'イベント出欠・点呼集計',
    markAllAttending: '全員「出席」にする',
    resetAll: 'リセット',
    in: '出席',
    out: '欠席',
    maybe: '保留',
    saveAttendance: '点呼を保存',
    cancel: 'キャンセル',
    successTitle: '出欠を更新しました',
    successMsg: '{title} の点呼結果を保存しました。',
  },
  settings: {
    title: '組織・テナント設定',
    subtitle: '{name} のClerkマルチテナント連携および設定管理',
    metadata: '組織メタデータ',
    orgName: '組織・クラブ名',
    seasonScope: '対象シーズン年度',
    savedMsg: '設定を正常に更新しました',
    saveChanges: '変更を保存',
    apiClerk: 'API & Clerk JWT インターセプター連携',
    apiClerkDesc: 'Axiosが自動的にClerk認証トークンおよび X-Tenant-Id ヘッダーを付与します。',
    tabConfig: 'テナント基本設定',
    tabMembers: 'メンバー管理＆招待',
    tabApi: 'APIスコーピング＆ヘッダー',
    membersTitle: 'テナントメンバー＆ロール管理 (RBAC)',
    membersSubtitle: 'ロール権限 (ADMIN, COACH, PLAYER, GUARDIAN) の設定とラスト管理者ガードレール保護。',
    lastAdminNotice: 'ラスト管理者ガードレール稼働中: 最低1名以上の管理者が必須です。現在の管理者数: {count}名',
    softDeletionMode: '論理削除・権限剥奪モード',
    colMemberName: '氏名',
    colEmail: 'メールアドレス',
    colAssignedTeam: '所属チーム',
    colRole: '権限ロール (RBAC)',
    colAccess: 'アクセス管理',
    unassigned: 'チーム未割当',
    lastAdminBadge: '最後の管理者',
    lastAdminTooltip: 'ロール変更不可: 組織には最低1名のアクティブな組織管理者が必要です。',
    revokeTooltip: '権限剥奪不可: 最後の組織管理者のアクセス権を剥奪することはできません。',
    revokeBtn: 'テナント権限を剥奪',
    revokeConfirm: '{name} のアクセス権限を剥奪しますか？割り当て済みのサービス枠はプールに返却されます。',
    apiScopingTitle: '独自データベースマルチテナント・スコーピング',
    apiScopingSubtitle: '全バックエンドAPIリクエストに付与 (/api/v1/...)',
    apiScopingDesc: 'ユーザー認証はClerk JWTで検証され、組織メンバーシップおよび権限はPostgreSQLモデルに紐付きます。',
    classificationTier: '区分・ティア (Tier)',
    sportType: '種目 (Sport Type)',
    seasonYear: 'シーズン年度',
  },
  seatAllocation: {
    modalTitle: 'サービス席数・ライセンス割り当て',
    modalSubtitle: '{service} の契約シート数を選手・スタッフに割り当てます。',
    utilization: 'シート利用率:',
    seatsContracted: '{count} 席 契約中',
    available: '残り {count} 席',
    assignSectionTitle: 'チームメンバーへのシート割り当て',
    selectPlaceholder: '割り当てる選手またはスタッフを選択...',
    assignBtn: 'シートを割り当てる',
    capacityFullWarning: 'シート上限に達しています ({total}/{total})。プランをアップグレードするか、未使用のシートを解除してください。',
    activeMembersTitle: '割り当て中のメンバー ({count}名)',
    searchPlaceholder: '割り当て済みメンバーを検索...',
    colMember: 'メンバー名',
    colRoleJersey: 'ロール / 背番号',
    colAssignedDate: '割り当て日',
    colAction: '操作',
    noAssigned: '現在このサービスに割り当てられたメンバーはいません。',
    unassignBtn: '解除',
    unassignConfirm: '{name} からシートを解除しますか？シートは空き枠に戻ります。',
    ledgerBadge: 'PostgreSQLリアルタイム台帳',
    close: '閉じる',
    assignedSuccess: 'サービスシートを正常に割り当てました',
    unassignedSuccess: '{name} のシート割り当てを解除しました',
    noServiceAssigned: 'サービスが割り当てられてません',
  },
  capacityExceeded: {
    title: 'シート契約上限を超過しました',
    badge: '409 Conflict',
    defaultMsg: '契約シート数を超える割り当てリクエストです。',
    contractedSeats: '契約シート数:',
    currentlyAllocated: '現在割当数:',
    requestedAdditional: '追加リクエスト:',
    overage: '超過数:',
    seatsNeeded: '+{count} 席の追加契約が必要です',
    coachNotice: 'コーチ権限ではプランのアップグレードは行えません。組織管理者に追加枠の申請を依頼してください。',
    cancelBtn: 'キャンセル',
    upgradeBtn: 'プランをアップグレード',
  },
  invoices: {
    title: '請求書・決済履歴',
    subtitle: 'PDF領収書・適格請求書のダウンロード、チーム一括および個別会費の支払い状況確認。',
    refreshBtn: '履歴を更新',
    tabTenant: 'チーム・組織請求',
    tabIndividual: '個人別請求',
    colInvoiceNum: '請求書番号',
    colDate: '請求日',
    colDescription: '内容',
    colBilledOrg: '請求先組織',
    colAthletePayer: '選手・支払者',
    colService: '対象サービス',
    colAmount: '金額',
    colStatus: 'ステータス',
    colDownload: '領収書',
    noTenantInvoices: 'チーム決済の請求書は見つかりませんでした。',
    noIndividualInvoices: '個人決済の請求書履歴はありません。',
    pdfBtn: 'PDF',
  },
  memberInvite: {
    drawerTitle: 'チームメンバーを招待',
    infoTip: '招待されたメンバーには案内メールが届き、独自テナント配下のアカウントを作成して参加できます。',
    emailLabel: '招待先メールアドレス',
    emailPlaceholder: "例: kudo.coach{'@'}nextbase.co.jp",
    roleLabel: '付与ロール (RBAC)',
    teamLabel: '所属チーム指定 (任意)',
    teamPlaceholder: '所属チームを選択...',
    rolePermissions: 'ロール権限の詳細:',
    adminDesc: '組織設定、メンバー管理、招待、サービス契約、Stripe請求ポータル、シート割り当ての全権限。',
    coachDesc: 'ロスター、スタメンオーダー、試合・練習日程、シート割り当ての管理。(決済・契約変更は不可)。',
    playerDesc: '個人のスケジュール閲覧、出欠回答、プロフィール、個別会費・サブスクの決済。',
    guardianDesc: '選手本人のスケジュール閲覧、出欠回答、プロフィール、個別会費・サブスクの決済。',
    cancelBtn: 'キャンセル',
    sendBtn: '招待メールを送信',
    successMsg: '{email} に招待メールを送信しました',
    invalidEmail: '有効なメールアドレスを入力してください。',
  },
  common: {
    home: 'ホーム',
    away: 'ビジター',
    active: '現役・出場可',
    injured: '故障者リスト (IL)',
    reserve: 'リザーブ・待機',
    cancel: 'キャンセル',
    save: '保存',
    sync: '同期',
    refresh: '更新',
    close: '閉じる',
    delete: '削除',
    edit: '編集',
    loading: '読み込み中...',
    actions: '操作',
  },
  auth: {
    signInTitle: 'Next Base にログイン',
    signInSubtitle: 'マルチテナント野球オペレーション基盤にアクセス',
    clerkAuth: 'Clerk認証:',
    apiTarget: 'APIエンドポイント:',
    clientTrustTitle: 'Clerkボット・端末信頼性検証',
    clientTrustDesc: 'Clerk Bot Detection (Cloudflare Turnstile) による対話型認証が必要です。認証が完了すると、自動的にダッシュボードへ遷移します。',
    dialogNotShowing: '認証ダイアログが表示されない場合',
    openVerificationModal: 'Clerk認証モーダルを開く',
    authNotice: '認証に関するお知らせ',
    registerNewAccount: '新しい組織を新規登録 →',
    emailLabel: 'メールアドレス',
    emailPlaceholder: "k.takahashi{'@'}nextbase.co.jp",
    passwordLabel: 'パスワード',
    passwordPlaceholder: 'パスワードを入力',
    signInBtn: 'ログイン',
    clerkModalBtn: 'Clerkモーダル画面',
    registerNewOrg: '新しい野球組織・クラブを登録',
    authComplete: '認証完了',
    welcomeBack: '{name} さん、おかえりなさい！',
    missingCreds: '入力情報が不足しています',
    missingCredsMsg: 'メールアドレスとパスワードの両方を入力してください。',
    authenticating: '認証中',
    connectingToClerk: '{email} のClerk認証に接続中...',
    verificationRequired: '認証が必要です',
    verificationChallenge: '認証ダイアログ内の確認を完了してください。',
    authFailed: '認証に失敗しました',
    couldNotSignIn: '指定された認証情報でサインインできませんでした。',
    authSuccess: '認証が成功しました',
    subRequired: 'サブスクリプション契約が必要です',
    subRequiredMsg: '機能を利用するには、チームプランの契約を有効化してください。',
    orContinueWith: 'またはソーシャルでログイン',
    orSignUpWith: 'またはソーシャルで登録',
  },
  onboarding: {
    joinedOrgTitle: '参加中の組織・クラブ',
    joinedOrgSubtitle: '認証されたテナント組織に紐付いています。',
    orgType: '{type} 組織',
    enterWorkspace: '組織ワークスペースに入る',
    registerNewOrg: '新しい野球組織・クラブを登録',
  },
  lineupCard: {
    modalTitle: '審判提出用 公式オーダー表',
    headerBadge: '公式打順・守備配置表',
    division: '所属ディビジョン',
    headCoach: '監督',
    date: '日付',
    verified: '認証済み',
    num: '背番号',
    pos: '守備',
    managerSig: '監督署名',
    umpireSig: '球審署名',
    printBtn: 'オーダー表を印刷',
  },
  recruitingHub: {
    title: '大学・プロスカウト進路指導ハブ',
    verifiedBadge: 'NCAA公認スカウト',
    subtitle: '{name} の選手スカウトシート、公認レーダー測定値、進路パイプライン',
    commitsBadge: '{count} 名 進路決定 (D1/D2)',
    topExitVelo: '最高打球初速 (公認)',
    fastest60: '最速60ヤード走',
    avgGpa: '選手平均GPA (評定)',
    searchPlaceholder: '選手名、学校名、ポジションで検索...',
    allGradClasses: '全卒業年度',
    class2025: '2025年卒 (高校3年)',
    class2026: '2026年卒 (高校2年)',
    class2027: '2027年卒 (高校1年)',
    allStatuses: '全進路ステータス',
    uncommittedOnly: '進路未定のみ',
    committedOnly: '進路決定済み',
    colProspect: '選手名',
    colClass: '学年',
    colExitVelo: '打球初速',
    colArmVelo: '送球速度',
    colSixty: '60ヤード',
    colGpa: 'GPA',
    colStatusSchool: '進路先・状況',
    colScoutPacket: 'スカウト資料',
    uncommittedTag: '進路未定',
    copyLinkTitle: 'スカウト用認証リンクをコピー',
    downloadPdfTitle: '1枚PDFプロファイルをダウンロード',
    dossierTitle: '公認スカウティング調書',
    peakExitVelo: '最高打球速度',
    infieldArmVelo: '内野送球速度',
    sixtyYardDash: '60ヤード走',
    heightWeight: '身長 / 体重',
    recruitingPipeline: '志望・接触大学パイプライン',
    copyRecruiterLink: 'スカウト用リンクをコピー',
    downloadPdfPacket: 'PDF資料をダウンロード',
    scoutLinkCopied: 'スカウトリンクをコピーしました',
    scoutLinkCopiedMsg: '{name} 選手のNCAAスカウトリンクをコピーしました',
    generatingScoutPacket: 'スカウト資料を生成中',
    generatingScoutPacketMsg: '#{num} {name} 選手のTrackMan測定値および4K映像レポートを作成中...',
  }
};